var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreatsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.8333C16.6666 15 13.7499 17.0833 10.2833 18.2916C10.1017 18.3531 9.90453 18.3502 9.72492 18.2833C6.24992 17.0833 3.33325 15 3.33325 10.8333V4.99997C3.33325 4.77895 3.42105 4.56699 3.57733 4.41071C3.73361 4.25443 3.94557 4.16663 4.16659 4.16663C5.83325 4.16663 7.91658 3.16663 9.36658 1.89997C9.54313 1.74913 9.76771 1.66626 9.99992 1.66626C10.2321 1.66626 10.4567 1.74913 10.6333 1.89997C12.0916 3.17497 14.1666 4.16663 15.8333 4.16663C16.0543 4.16663 16.2662 4.25443 16.4225 4.41071C16.5788 4.56699 16.6666 4.77895 16.6666 4.99997V10.8333Z",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66675V10.0001",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333H10.0083",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatsB);
export default __webpack_public_path__ + "static/media/threatsB.bd07f36e8fd9361f9d2fe12896293c33.svg";
export { ForwardRef as ReactComponent };